import { render, staticRenderFns } from "./journey-enable-widget.vue?vue&type=template&id=3ff58194&"
import script from "./journey-enable-widget.vue?vue&type=script&lang=js&"
export * from "./journey-enable-widget.vue?vue&type=script&lang=js&"
import style0 from "./journey-enable-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports